// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f822dd7","455":"11e2c09c","749":"d2d98f97","815":"f19a6882","857":"37fdc849","903":"6315f363","951":"3d8213ff","977":"54f4e5fd"}[chunkId] + ".chunk.js";
};